export default __webpack_public_path__ + "7cebf3bdcd9389c6d1285410ab36834a.jpg";